window.MTGGoldfish = window.MTGGoldfish || {};
window.MTGGoldfishDygraph = window.MTGGoldfishDygraph || {};
window.MTGGoldfishMetagame = window.MTGGoldfishMetagame || {};

document.addEventListener("DOMContentLoaded", function() {
  if ($.isArray(window.MTGGoldfish.onDocumentReadyArray)) {
    for (var i=0; i < window.MTGGoldfish.onDocumentReadyArray.length; i++) {
      window.MTGGoldfish.onDocumentReadyArray[i]();
    }
  }
  if (typeof window.MTGGoldfish.onDocumentReady == 'function') { window.MTGGoldfish.onDocumentReady(); }
  if (typeof window.MTGGoldfishDygraph.onDocumentReady == 'function') { window.MTGGoldfishDygraph.onDocumentReady(); }
  if (typeof window.MTGGoldfishMetagame.onDocumentReady == 'function') { window.MTGGoldfishMetagame.onDocumentReady(); }
});
